import {RblNestResourceInterface} from "../rbl-resource.interface";
import {uString, Uuid} from "@hidat/huijs-common";
import {LocalDate} from "@js-joda/core";
import {ResourceConfig} from "@hidat/huijs-resource";

export const PlaylistShareConfig = new ResourceConfig('PlaylistShare', 'playlist_shares')

export interface PlaylistShareInterface extends RblNestResourceInterface {
  shareType: uString;
  email: uString;
  //magicLink: uString;
  startsAt: LocalDate | undefined | null;
  endsAt: LocalDate | undefined | null;
  playlistPageId: Uuid | undefined;
  playlistLogId: Uuid | undefined;
  //acceptStatus: uNumber;
}
